module.exports = __webpack_public_path__ + "static/html-1d66013f5f896dd5e206885495fb564c.png";